module.exports = __webpack_public_path__ + "img/logo_col.2503820f.png";